<template>
    <b-modal ref="profile_modal" size="lg" bodyClass="p-0" v-bind:no-close-on-backdrop=true :hide-header=true v-model="is_show_modal" :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 v-if="cur_item.id > 0">
                    <span class="fw-300">ID:{{this.cur_item.id}} | {{this.cur_item.title}}</span>
                </h2>
                
                <h2 v-else>
                    -
                </h2>
                
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="panel-container show p-3">
                <div class="steps"  v-if="cur_item.id > 0">
                    <div class="d-flex flex-row align-items-center p-2">
                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-building icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3"><strong>
                            Номер службової
                        </strong> <br>
                            <a :href="'https://office.imcagro.com.ua/docs/memorandum/' + this.memorandum.id" target="_blank">
                                {{this.memorandum.number}}
                            </a>
                        </div>
                    </div>
                    
                    <div class="d-flex flex-row align-items-center p-2">
                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-calendar-day icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3"><strong>
                            Дата:
                        </strong> <br>
                            {{this.cur_item.mem_added}}
                        </div>
                    </div>
                    
                    
                    <div class="d-flex flex-row align-items-center p-2">
                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-chalkboard-teacher icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3"><strong>
                            Співробітник:
                        </strong> <br>
                            {{this.cur_item.init_user}}
                        </div>
                    </div>
                    
          
                    <div class="d-flex flex-row align-items-center p-2"  v-if="this.cur_item.hasOwnProperty('trip_from')">
                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-building icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3"><strong>
                            з:
                        </strong> <br>
                            {{this.cur_item.trip_from}}
                        </div>
                    </div>
                    
                    
                    
                    <div class="d-flex flex-row align-items-center p-2" v-if="this.cur_item.hasOwnProperty('trip_to')">
                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-calendar-day icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3"><strong>
                            до:
                        </strong> <br>
                            {{this.cur_item.trip_to}}
                        </div>
                    </div>
                    
                    
                    <div class="d-flex flex-row align-items-center p-2" v-if="this.cur_item.hasOwnProperty('car')">
                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-car-side icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3"><strong>
                            Транспорт:
                        </strong> <br>
                            {{this.cur_item.car.title}}
                        </div>
                    </div>
                    
                    <div class="d-flex flex-row align-items-center p-2">
                        <div class="icon-stack display-3 flex-shrink-0">
                            <i class="fal fa-circle icon-stack-3x opacity-100 color-primary-400"></i>
                            <i class="fas fa-envelope-open-text icon-stack-1x opacity-100 color-primary-500"></i>
                        </div>
                        <div class="ml-3">
                            <strong>Опис:</strong>
                            <br>
                            <div v-html="memorandum.pre_text"></div>
                        </div>
                    </div>
                    
                    
                </div>
            </div>
            <!--FOOTER -->
        </div>
        
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                
                <button type="button" v-on:click="close_mod" class="btn btn-secondary waves-effect waves-themed">
                    Закрити
                </button>
            </div>
        </template>
    </b-modal>
</template>


<script>
export default {
    name: "trip_modal",
    created() {
        EventBus.$on('show_trip',this.show_item)
    },
    
    data() {
        return {
            is_load : false,
            is_show_modal : false,
            cur_item : {
                "id" : 0,
            }
        }
    },
    
    methods : {
        
        show_item(event) {
            this.is_show_modal = true;
            console.log("%c Show Trip ", "color: #fd3995",event);
            this.load_item_info(event.event_id);
        },
        
        async load_item_info(trip_id) {
            this.cur_item = {
                id : trip_id,
            };
            
            await api.get('/calendar/trips/' + trip_id).then(({data}) => {
                this.is_load = false;
                if (data.status == "operation_success") {
                    this.cur_item = data.data;
                }
            }).catch(err => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err:err.message ,type:"danger",title:err.name})
            });
        },
        
        close_mod() {
            this.close();
        },
        
        close() {
            this.cur_item = {
                id : 0,
            };
            this.is_show_modal = false;
            
        },
    },
    
    computed : {
        
        memorandum () {
            if(this.cur_item.hasOwnProperty("memorandum")) {
                return this.cur_item.memorandum;
            }
            
            return {
                "number" : "",
            };
        },
        
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-xl";
            }
            
            return "modal-dialog-right modal-xl";
        },
        
    }
}
</script>



<style scoped>

</style>